import { render, staticRenderFns } from "./AdministrationNav.vue?vue&type=template&id=1b745b92&"
import script from "./AdministrationNav.vue?vue&type=script&lang=js&"
export * from "./AdministrationNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports